import { Text } from '@mantine/core'
import {
  ColumnDef,
  createColumnHelper,
  DisplayColumnDef,
} from '@tanstack/react-table'

const descriptionColumn = <
  T extends Record<'description', string | null>,
>(params?: {
  accessor?: (row: T) => string | null
  column?: Partial<DisplayColumnDef<T, string | null>>
}): ColumnDef<T, string | null> => {
  const columnHelper = createColumnHelper<T>()

  const defaultAccessor: (row: T) => string | null = (row) => {
    return row.description
  }

  const accessorFn = params?.accessor ?? defaultAccessor

  const descriptionColumn = columnHelper.accessor(accessorFn, {
    header: i18n.t('columnsdescription', 'Beschreibung'), //i18n.t('columns.description', { ns: 'common' }).toString(),
    id: 'description',
    minSize: 40,
    cell: (cell) =>
      cell.getValue() ? (
        <Text>{cell.getValue()}</Text>
      ) : (
        <Text color="dimmed">
          {i18n.t('columnsvalue_not_set', 'Nicht gesetzt')}
          {/* {i18n.t('columns.value_not_set', { ns: 'common' }).toString()} */}
        </Text>
      ),
    ...params?.column,
  })

  return descriptionColumn
}

export default descriptionColumn
